module.exports = __webpack_public_path__ + "static/media/sidd_logo5.9336c5b0.png";